import Paragraph from "antd/es/typography/Paragraph";
import Title from "antd/es/typography/Title";
import { useGetMeQuery } from "api/User/hooks.ts";
import { AccountGlobalFieldsSection } from "components/AccountSettings/AccountGlobalFieldsSection.tsx";
import { AccountSettingsCollapsibleCard } from "components/AccountSettings/AccountSettingsCollapsibleCard.tsx";
import { AccountForm } from "components/Forms/AccountForm/AccountForm";
import {
    AccountProfileForm,
    AccountProfileFormAffiliateContent,
    AccountProfileFormSettingsContent,
} from "components/Forms/AccountProfileForm/AccountProfileForm";
import { AccountPage } from "components/UI/AccountPage/AccountPage.tsx";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { Trans, usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { useState } from "react";
import { FormId } from "types/models";
import { getAccountSettingsHeaderItems } from "utils/accountHeaderItems.ts";

export function AccountSettingsPage() {
    const { t: tPage } = usePaldockTranslation("pages.account");
    const [showPasswordForm, setShowPasswordForm] = useState(false);
    const getMeQuery = useGetMeQuery({});
    const email = getMeQuery.data?.user?.email ?? null;

    return (
        <AccountPage headerNavigationItems={getAccountSettingsHeaderItems} saveFormId={FormId.AccountProfileForm}>
            <AccountProfileForm>
                <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                    <div className="flex flex-col gap-y-6">
                        <SectionContentWrapper withBackground>
                            <Title level={3} className="!mb-6">
                                {tPage("sections.settings.title")}
                            </Title>
                            <AccountProfileFormSettingsContent email={email} />

                            <div className="mt-4">
                                <button
                                    type="button"
                                    className="text-sm text-primary hover:underline"
                                    onClick={() => setShowPasswordForm((value) => !value)}
                                >
                                    {showPasswordForm
                                        ? tPage("actions.hide_reset_password")
                                        : tPage("actions.reset_password")}
                                </button>
                                {showPasswordForm && (
                                    <div className="mt-4">
                                        <AccountForm />
                                    </div>
                                )}
                            </div>
                        </SectionContentWrapper>

                        <AccountSettingsCollapsibleCard title={tPage("sections.personal_data.title")}>
                            <AccountGlobalFieldsSection section="personal" />
                        </AccountSettingsCollapsibleCard>

                        <AccountSettingsCollapsibleCard title={tPage("sections.affiliate_propagation.title")}>
                            <AccountProfileFormAffiliateContent />
                        </AccountSettingsCollapsibleCard>
                    </div>

                    <div className="flex flex-col gap-y-6">
                        <AccountSettingsCollapsibleCard title={tPage("sections.contact_data.title")}>
                            <AccountGlobalFieldsSection section="contact" />
                        </AccountSettingsCollapsibleCard>

                        <AccountSettingsCollapsibleCard title={tPage("sections.company_data.title")}>
                            <AccountGlobalFieldsSection section="company" />
                        </AccountSettingsCollapsibleCard>

                        <SectionContentWrapper withBackground>
                            <Title level={3} className="!mb-6">
                                {tPage("sections.terms.title")}
                            </Title>
                            <Paragraph className="!mb-4 text-gray-600">{tPage("sections.terms.description")}</Paragraph>
                            <Paragraph>
                                <Trans
                                    i18nKey="pages.account.sections.terms.view_link"
                                    components={{
                                        a: (
                                            <a
                                                href="https://paldock.fra1.cdn.digitaloceanspaces.com/Leadgenia.com%20VOP.pdf"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-blue-600 !underline hover:!no-underline"
                                            />
                                        ),
                                    }}
                                />
                            </Paragraph>
                        </SectionContentWrapper>
                    </div>
                </div>
            </AccountProfileForm>
        </AccountPage>
    );
}
